export const countries = {
  '': 'Select Country',
  us: 'United States',
  uk: 'United Kingdom',
  au: 'Australia',
  nz: 'New Zealand',
  in: 'India',
  at: 'Austria',
  be: 'Belgium',
  bg: 'Bulgaria',
  ca: 'Canada',
  co: 'Colombia',
  hr: 'Croatia',
  cy: 'Cyprus',
  dk: 'Denmark',
  ee: 'Estonia',
  fi: 'Finland',
  fr: 'France',
  de: 'Germany',
  el: 'Greece',
  hu: 'Hungary',
  ie: 'Ireland',
  it: 'Italy',
  lv: 'Latvia',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  mt: 'Malta',
  mx: 'Mexico',
  nl: 'Netherlands',
  pl: 'Poland',
  pt: 'Portugal',
  ro: 'Romania',
  sk: 'Slovakia',
  si: 'Slovenia',
  es: 'Spain',
  se: 'Sweden',
  ae: 'United Arab Emirates',
  ar: 'Argentina',
  ch: 'Switzerland',
  br: 'Brazil',
  ph: 'Philippines',
  ma: 'Morocco',
  cz: 'Czech Republic',
  gr: 'Greece',
  sg: 'Singapore',
  tr: 'Turkey',
  id: 'Indonesia',
  sx: 'Sint Maarten',
  hk: 'Hong Kong',
  al: 'Albania',
  dz: 'Algeria',
  ao: 'Angola',
  ag: 'Antigua and Barbuda',
  am: 'Armenia',
  az: 'Azerbaijan',
  bs: 'Bahamas',
  bh: 'Bahrain',
  bd: 'Bangladesh',
  bj: 'Benin',
  bt: 'Bhutan',
  bo: 'Bolivia, Plurinational State of',
  ba: 'Bosnia and Herzegovina',
  bw: 'Botswana',
  bn: 'Brunei Darussalam',
  kh: 'Cambodia',
  cl: 'Chile',
  cr: 'Costa Rica',
  ci: "Cote d'Ivoire",
  do: 'Dominican Republic',
  ec: 'Ecuador',
  eg: 'Egypt',
  et: 'Ethiopia',
  ga: 'Gabon',
  gm: 'Gambia',
  gh: 'Ghana',
  gi: 'Gibraltar',
  gt: 'Guatemala',
  gy: 'Guyana',
  is: 'Iceland',
  il: 'Israel',
  jm: 'Jamaica',
  jp: 'Japan',
  jo: 'Jordan',
  kz: 'Kazakhstan',
  ke: 'Kenya',
  kr: 'Korea, Republic of',
  kw: 'Kuwait',
  la: "Lao People's Democratic Republic",
  li: 'Liechtenstein',
  mo: 'Macao',
  mk: 'Macedonia',
  mg: 'Madagascar',
  my: 'Malaysia',
  mu: 'Mauritius',
  md: 'Moldova, Republic of',
  mc: 'Monaco',
  mn: 'Mongolia',
  mz: 'Mozambique',
  na: 'Namibia',
  ne: 'Niger',
  ng: 'Nigeria',
  no: 'Norway',
  om: 'Oman',
  pk: 'Pakistan',
  pa: 'Panama',
  py: 'Paraguay',
  pe: 'Peru',
  qa: 'Qatar',
  lc: 'Saint Lucia',
  lk: 'Sri Lanka',
  th: 'Thailand',
  fj: 'Fiji',
}
